import styled from 'styled-components'

interface GridContainerWrapperProps {
  pageBottomPadding?: boolean
  overflowX?: string
  topBorderColour?: string
}

export const StyledGridContainerWrapper = styled.div<GridContainerWrapperProps>`
  padding-bottom: ${({ pageBottomPadding }) =>
    pageBottomPadding ? '20px' : ''};
  overflow-x: ${({ overflowX }) => (overflowX ? overflowX : 'visible')};
  border-top: 1px solid
    ${({ topBorderColour }) => (topBorderColour ? topBorderColour : 'none')};
`
